interface TypesById {
  [key: number]: string;
}
export const types: TypesById = {
  1: '财富',
  2: '守护',
  3: '购买',
  4: '活动',
  5: '道具',
  6: '贵族',
  8: 'VIP'
};
